import React, { forwardRef, useEffect, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import inputsConfig from "./constants/inputsConfig";
import set from "lodash/set";
import { StyledForm, AccordionContent } from "./container.style";
import Accordion from "../../formComponents/accordion/accordion.component";
import Section from "../../formComponents/section/section.component";
import { Button } from "@mbo/forms";
import { objectToDotNotation } from "../../../../utils";

const Form = forwardRef(
  (
    {
      structure,
      onPostForm,
      onPostFormError,
      contestType,
      challenge,
      serverErrors,
    },
    ref,
  ) => {
    const config = inputsConfig[contestType];
    const defaults = Object.values(config).reduce(
      (obj, val) => set(obj, val.name, val.default),
      {},
    );
    const forForm = challenge ?? defaults;
    const [openedAccordion, setOpenedAccordion] = useState(0);
    const formMethods = useForm({
      mode: "onTouched",
      defaultValues: {
        ...forForm,
        contest_type: contestType,
      },
    });
    const { reset, getValues, setError } = formMethods;

    useEffect(() => {
      if (contestType === getValues().contest_type) return;
      reset({
        ...defaults,
        contest_type: contestType,
      });
    }, [contestType, defaults, getValues, reset]);

    useEffect(() => {
      if (!serverErrors) return;

      Object.entries(objectToDotNotation(serverErrors)).forEach(
        ([field, message]) => setError(field, { type: "server", message }),
      );
    }, [serverErrors, setError]);

    const renderSections = (sections) =>
      sections.map((section, idx) => <Section key={idx} data={section} />);

    const { items } = structure;
    const renderForm = structure.accordion ? (
      Object.entries(items).map(([label, sections], idx) => (
        <Accordion
          key={idx}
          idx={idx}
          title={label}
          isOpen={idx === openedAccordion}
          setIsOpen={() => setOpenedAccordion(idx)}
        >
          <AccordionContent>{renderSections(sections)}</AccordionContent>
        </Accordion>
      ))
    ) : (
      <AccordionContent>{renderSections(structure.items)}</AccordionContent>
    );

    const handleSubmit = (data) => onPostForm(data, reset);

    return (
      <FormProvider {...formMethods}>
        <StyledForm
          ref={ref}
          onSubmit={formMethods.handleSubmit(handleSubmit, onPostFormError)}
          noValidate={true}
          $withoutAccordion={structure.accordion ? 1 : 0}
        >
          {renderForm}
          {!structure.accordion && <hr />}
          <AccordionContent
            className="button-container"
            $withoutAccordion={structure.accordion ? 1 : 0}
          >
            <Button variant="action" round type="submit" size="xl">
              Submit
            </Button>
          </AccordionContent>
        </StyledForm>
      </FormProvider>
    );
  },
);
Form.displayName = "Form";

export default Form;
